import Select from '@/components/Select/Select'
import {SortBy} from '@/lib/flight/types'

import style from './FlightSorter.module.scss'

interface Props {
  sorter: SortBy
  setSorter: MemoizedCallbackOrDispatch<SortBy>
}

const OPTIONS = [
  {
    label: 'Price',
    value: SortBy.Price,
  },
  {
    label: 'Departure time',
    value: SortBy.DepartureTime,
  },
  {
    label: 'Arrival time',
    value: SortBy.ArrivalTime,
  },
  {
    label: 'Duration',
    value: SortBy.Duration,
  },
]

export default memo(function FlightSorter({sorter, setSorter}: Props) {
  return (
    <Select
      className={style.Select}
      buttonProps={{className: style.Button}}
      popoverProps={{className: style.Popover}}
      prefix={<span aria-hidden>Sort by:</span>}
      label='Sort by'
      options={OPTIONS}
      selectedItem={sorter}
      setSelectedItem={setSorter}
    />
  )
})
